export const commonTranslations = {
  en: {
    // Navigation
    home: 'Home',
    about: 'About',
    services: 'Services',
    pricing: 'Pricing',
    contact: 'Contact',
    login: 'Login',
    register: 'Register',
    chat: 'Chat',
    
    // Actions
    getStarted: 'Get Started',
    contactUs: 'Contact Us',
    learnMore: 'Learn More',
    sendMessage: 'Send Message',
    backToHome: '← Back to Home',
    
    // Company Info
    companyName: 'DESTA TEAM',
    companyTagline: 'Software Engineers',
    
    // Contact Details
    email: 'Email',
    telegram: 'Instagram', 
    phone: 'Phone',
    website: 'Website',
    
    // General
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    cancel: 'Cancel',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    
    // Footer
    allRightsReserved: 'All rights reserved.',
    quickLinks: 'Quick Links',
    navigation: 'Navigation',
    
    // Languages
    english: 'English',
    ukrainian: 'Українська',
    
    // Buttons
    selectPlan: 'Select Plan',
    
    // Assessment Page
    assessments: {
      title: 'Your AI Assessments',
      subtitle: 'View all your product assessments and AI-powered recommendations',
      loading: 'Loading your assessments...',
      noAssessments: 'No Assessments Yet',
      noAssessmentsText: 'Start your AI-powered product journey with our free assessment!',
      takeAssessment: 'Take Free Assessment',
      newAssessment: 'New Assessment',
      viewAssessment: 'View Full Assessment',
      hideAssessment: 'Hide Assessment Details',
      freeAssessment: 'Free Assessment', 
      premiumAssessment: 'Premium Assessment',
      completed: 'Completed',
      aiAnalysisAvailable: 'Available',
      productType: 'Product Type',
      status: 'Status',
      aiAnalysis: 'AI Analysis',
      goDashboard: 'Go to Dashboard',
      backToHome: 'Back to Home',
      fullProgram: 'Full Program',
      singleModule: 'Single Module'
    }
  },
  uk: {
    // Navigation
    home: 'Головна',
    about: 'Про нас',
    services: 'Послуги',
    pricing: 'Ціни',
    contact: 'Контакти',
    login: 'Увійти',
    register: 'Реєстрація',
    chat: 'Чат',
    
    // Actions
    getStarted: 'Розпочати',
    contactUs: 'Зв\'язатися з нами', 
    learnMore: 'Дізнатися більше',
    sendMessage: 'Надіслати повідомлення',
    backToHome: '← Повернутися на головну',
    
    // Company Info
    companyName: 'DESTA TEAM',
    companyTagline: 'Інженери програмного забезпечення',
    
    // Contact Details
    email: 'Пошта',
    telegram: 'Instagram',
    phone: 'Телефон', 
    website: 'Веб-сайт',
    
    // General
    loading: 'Завантаження...',
    error: 'Помилка',
    success: 'Успіх',
    cancel: 'Скасувати',
    save: 'Зберегти',
    edit: 'Редагувати',
    delete: 'Видалити',
    
    // Footer
    allRightsReserved: 'Всі права захищені.',
    quickLinks: 'Швидкі посилання',
    navigation: 'Навігація',
    
    // Languages
    english: 'English',
    ukrainian: 'Українська',
    
    // Buttons
    selectPlan: 'Вибрати план',
    
    // Assessment Page
    assessments: {
      title: 'Ваші ШІ Оцінювання',
      subtitle: 'Переглядайте всі ваші оцінки продуктів та рекомендації на основі ШІ',
      loading: 'Завантаження ваших оцінок...',
      noAssessments: 'Поки що немає оцінок',
      noAssessmentsText: 'Розпочніть свою подорож з ШІ-продуктами з безкоштовного оцінювання!',
      takeAssessment: 'Пройти безкоштовне оцінювання',
      newAssessment: 'Нове оцінювання',
      viewAssessment: 'Переглянути повне оцінювання',
      hideAssessment: 'Сховати деталі оцінювання',
      freeAssessment: 'Безкоштовне оцінювання',
      premiumAssessment: 'Преміум оцінювання',
      completed: 'Завершено',
      aiAnalysisAvailable: 'Доступний',
      productType: 'Тип продукту',
      status: 'Статус',
      aiAnalysis: 'ШІ Аналіз',
      goDashboard: 'Перейти до Панелі',
      backToHome: 'Повернутися додому',
      fullProgram: 'Повна програма',
      singleModule: 'Модуль окремо'
    }
  }
};